import { KonditionenLoc } from '@/types/service-response'
import moment from 'moment'

export class ProjectBookingBelegKonditionenLoc {
  public constructor (
    readonly MitarbeiterID: number,
    readonly Datum: string,
    readonly LieferungID: number,
    readonly ZahlungID: number,
    readonly WaehrungID: number,
    readonly SteuerID: number
  ) {}

  static createFromResponse (responseData: KonditionenLoc): ProjectBookingBelegKonditionenLoc {
      return new ProjectBookingBelegKonditionenLoc(
        responseData.MitarbeiterID,
        responseData.Datum ? moment(responseData.Datum).format('YYYY-MM-DD') : '',
        responseData.LieferungID,
        responseData.ZahlungID,
        responseData.WaehrungID,
        responseData.SteuerID
      )
  }
}
